module.exports = __webpack_public_path__ + "static/media/mgf.e481d143.png";